import blue from '../../images/blue.webp';
import kris from '../../images/kris.webp';
import warren from '../../images/warren.webp';

const reviewData = [
    {
        name: "Blue larem",
        adress: "turkey",
        company: 'EXEChain',
        possition: 'Web Developer',
        description: "Is a constructive communicator and is capable of discussing difficult issues effectively and to the point",
        img: blue,
        fb: '',
        linkdein: '!#',
        rating: 5
    },
    {
        name: "Kristopher Scott",
        adress: "United States",
        company: 'EXEChain',
        possition: 'Web Developer',
        description: "I wanted to recognize ujjal zaman for all his professional expertise and hard work that he put forth for Exechain. <br/> His work ethic was remarkable; he exceed our expectations!",
        img: kris,
        fb: '',
        linkdein: '!#',
        rating: 5
    },
    {
        name: "Exe warren",
        adress: "United States",
        company: 'EXEChain',
        possition: 'Web Developer',
        description: "Positively contributes to the overall performance of the company through consistent and high-quality work.",
        img: warren,
        fb: '',
        linkdein: '!#',
        rating: 2

    },

    {
        name: "Kristopher Scott",
        adress: "United States",
        company: 'EXEChain',
        possition: 'Web Developer',
        description: "I wanted to recognize ujjal zaman for all his professional expertise and hard work that he put forth for Exechain. <br/> His work ethic was remarkable; he exceed our expectations!",
        img: kris,
        fb: '',
        linkdein: '!#',
        rating: 5
    },

]

export default reviewData;